import { formatDateRockset } from '../formatTimestamp';
import { getAuthToken } from '../../utils/auth';
import {
  searchReportingFetchJSON as safeFetchJSON,
  searchReportingLegacyUrl,
} from '../../lib/flags/search-reporting';

export async function queryPayouts(
  jwtToken,
  merchants,
  amountAtLeast,
  amountNoMoreThan,
  amountSpecific,
  filteredType,
  filteredState,
  filteredFormList,
  timerange,
  dateType,
  limit,
  searchAfter = undefined,
) {
  let states = [];
  for (const state of filteredState) {
    if (state === 'Paid') {
      states.push('PAID');
    } else if (state === 'Pending') {
      states.push('PENDING');
      states.push('IN_TRANSIT');
    } else if (state === 'Failed') {
      states.push('FAILED');
      states.push('CANCELED');
    } else if (state === 'Withdrawn') {
      states.push('WITHDRAWN');
    }
  }

  const { startDate, endDate } = timerange
    ? formatDateRockset(timerange)
    : { startDate: '', endDate: '' };

  const result = await safeFetchJSON(
    `${searchReportingLegacyUrl}/payouts`,
    {
      method: 'POST',
      headers: {
        Authorization: await getAuthToken(),
      },
      body: JSON.stringify({
        query: 'payouts',
        filters: {
          amountEquals: amountSpecific === '' ? '-1' : String(Number(amountSpecific) * 100),
          amountGreaterThan: amountAtLeast === '' ? '-1' : String(Number(amountAtLeast) * 100),
          amountLessThan: amountNoMoreThan === '' ? '-1' : String(Number(amountNoMoreThan) * 100),
          types: filteredType,
          statuses: states,
          merchantNames: merchants,
          startDate: startDate,
          endDate: endDate,
          dateType: dateType,
          limit: limit,
          ...(searchAfter !== undefined && { searchAfter }),
        },
      }),
    },
    {
      context: 'queryPayouts',
      retries: 2,
      retryDelay: 1000,
    },
  );

  if (!result.ok) {
    console.error('[PayoutsQueries] queryPayouts failed:', result.error);
    return [];
  }

  return result.data || [];
}
